var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlyKitted = function SvgPlyKitted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    "data-name": "Component 27 \\u2013 32",
    viewBox: "0 0 28 28"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00ce6b",
    stroke: "#92e9bf",
    strokeWidth: 3,
    "data-name": "Rectangle 4603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    stroke: "none",
    rx: 14
  }), /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    x: 1.5,
    y: 1.5,
    fill: "none",
    rx: 12.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "m9.278 14.064 4.07 4.459 6.445-8.742",
    "data-name": "Path 11639"
  })));
};
export default SvgPlyKitted;